const ctaDownloadApp = {
  enable: {
    desktop: true,
    mobile: true,
  },
}

export default ctaDownloadApp
